import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useConnect } from 'redux-bundler-hook';
import Drawer from 'root/components/molecules/Drawer';

import CreateTeamMemberForm from './components/CreateTeamMemberForm';
import { StyledConfirmMenu } from './styles';

const CreateTeamMember = ({ active }) => {
  const [showConfirmLeave, setShowConfirmLeave] = useState(false);
  const { doUpdateQuery, queryObject } = useConnect(
    'doUpdateQuery',
    'selectQueryObject',
  );
  const form = useForm({
    defaultValues: {
      assignedBoards: [],
      email: '',
      role: { label: 'User', value: 'user' },
    },
  });
  const { drawer, ...restQueryObject } = queryObject;
  const {
    formState: { isDirty },
  } = form;

  const handleClose = ({ ignore }) => {
    if (isDirty && !ignore) {
      // show confirm menu
      return setShowConfirmLeave(true);
    }

    if (showConfirmLeave) setShowConfirmLeave(false);
    return doUpdateQuery(restQueryObject);
  };

  return (
    <Drawer active={active} onClose={handleClose} title="Invite Member">
      <CreateTeamMemberForm form={form} onClose={handleClose} />
      <StyledConfirmMenu
        actionButtonTitle="Discard changes"
        onActionButton={() => handleClose({ ignore: true })}
        onCancel={() => setShowConfirmLeave(false)}
        showOnMobile
        subtitle="Are you sure you want to discard unsaved changes?"
        title="Discard"
        visible={showConfirmLeave}
      />
    </Drawer>
  );
};

CreateTeamMember.propTypes = {
  active: PropTypes.bool,
};

CreateTeamMember.defaultProps = {
  active: false,
};

export default CreateTeamMember;
